import { useEffect, useState } from 'react';
import { fetchConfig } from '../services/fetchConfig';

const GrafanaDashboard = () => {
  const baseUrl = process.env.REACT_APP_GRAFANA_URL;
  const [orangeAlertThreshold, setOrangeAlertThreshold] = useState();
  const [redAlertThreshold, setRedAlertThreshold] = useState();

  useEffect(() => {
    const setState = async () => {
      try {
        const config = await fetchConfig();
        setOrangeAlertThreshold(config.orange_alert_threshold || 2);
        setRedAlertThreshold(config.red_alert_threshold || 3);

        if (!config.orange_alert_threshold) {
          console.error('No orange alert threshold received from backend, defaulting to 2');
        }
        if (!config.red_alert_threshold) {
          console.error('No red alert threshold received from backend, defaulting to 3');
        }
      } catch (error) {
        console.error('Error fetching live dashboard config:', error);
      }
    };

    setState();
  }, []);

  const url = `${baseUrl}&var-orange_alert_threshold=${orangeAlertThreshold}&var-red_alert_threshold=${redAlertThreshold}`;

  console.log('Grafana Dashboard URL:', url);

  return (
    <iframe
      src={url}
      style={{ width: '100%', height: '100%', border: 'none' }}
      title="Grafana Dashboard"
    />
  );
};
export default GrafanaDashboard;
